import { AnalyticsSettings, User, YammerState } from '../../state/types';

type GetSelectedOnBehalfOfUserId = (state: YammerState) => User['id'] | undefined;
export const getSelectedOnBehalfOfUserId: GetSelectedOnBehalfOfUserId = (state) =>
  state.analyticsSettings.selectedOnBehalfOfUserId;

type GetSelectedNetworkActivitySettings = (state: YammerState) => AnalyticsSettings['networkActivitySettings'];
export const getSelectedNetworkActivitySettings: GetSelectedNetworkActivitySettings = (state) =>
  state.analyticsSettings.networkActivitySettings;
